import React from 'react'

const Button = ({ children, className = '', ...props }) => (
    <button {...props} className={`btn ${className}`}>
        {children}
    </button>
)

export default Button
